function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlanceclear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18250",
    transform: "translate(-564 -274)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 5853",
    width: 48,
    height: 48,
    rx: 8,
    transform: "translate(564 274)",
    style: {
      fill: "rgba(3,84,163,.1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "check (7)",
    d: "M20 6 9 17l-5-5",
    transform: "translate(576.5 286.5)",
    style: {
      fill: "none",
      stroke: "#0354a3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlanceclear);
export default __webpack_public_path__ + "static/media/blanceclear.54930cc6c55be97127188f0dc146abce.svg";
export { ForwardRef as ReactComponent };